// en
export default {
 offline_message: 'You are currently offline',
 rotate_message: 'Please rotate your device',
 errors: {
  '500': 'Please try again later',
  'offline': 'You are offline. Please check your internet connection.',
  exceed_daily_order_limit: 'Sorry, you have exceeded the daily purchase quota.',
  out_of_stock: 'This item is out of stock at the moment. Please remove item from your shopping bag to proceed.',
  not_enough_stock: 'Not enough stock.',
  not_allow_to_checkout: 'Item is not available for self-checkout. Please contact staff if you wish to purchase this item and remove it from the shopping bag to proceed.',
  max_items_reached: 'Sorry, Maximum quantity of 20 items per order exceeded.',
  max_qty_reached: 'Maximum quantity of {{max_qty}} exceeded. Please adjust quantity to proceed.'
 },
 labels: {
  exclusive: 'Exclusive',
  new: 'New',
  limited_edition: 'Limited Edition'
 },
 order_ready: 'Your order #{{ticket_number}} is ready for collection.',
 menu_list: {
  home: 'Home',
  all: 'All {{category}}'
 },
 containers: {
  cart: {
   title: 'Shopping Bag',
   empty_message: `Your shopping
   bag is empty`,
   shop_now: 'Shop Now',
   subtotal: 'Subtotal ',
   items: {
    one: '(1 item)',
    other: '({{count}} items)'
   },
   place_order_button: 'Place Order',
   place_order: 'Place Order',
   place_order_message: 'Are you sure you want to place this order?',
   payment_redirect_message: 'You will be redirected to the payment page, please complete the payment within 10 minutes.',
   pay_at_cashier_message: 'Please proceed to check out at the cashier within 1 hour after placing the order.',
   yes: 'Yes',
   no: 'No',
   dismiss: 'Dismiss',
   bag_charge_message: 'HK ${{fee}} will be charged for gift carrier bags according to Hong Kong plastic shopping bag environmental levy scheme',
   // staff_code_label: 'For Official Use',
   // staff_code_placeholder: 'Staff Code',
   out_of_stock_error: 'This item is out of stock at the moment. Please remove item from your shopping bag to proceed.',
   load_error: 'Please try again later',
   reload_btn: 'Retry',
   deferred_payment: 'Other: payment',
   notice_title: 'Notice',
   invalid_card: 'Invalid Card for Apple Pay',
   other_footnote: 'To pay by cash or union pay, please make the payment at the cashier'
  },
  check_in: {
   select_language: 'Select Language',
   notice_message: 'Sorry. You must check in before you can start. Please present QR code to staff to check in.',
  },
  order_list: {
   title: 'Your Orders',
   thank_you_title: 'Thank You<br />For Your Order',
   collect_message: 'Your payment is successful. Please pick up at the cashier when ready',
   pay_and_collect_message: 'Please pay and collect at the cashier when ready',
   order_ready_title: 'Your Order Is Ready<br />For Collection',
   ticket_no_label: 'Your Ticket Number',
   qrcode_message: 'Present QR code<br />when collecting your order',
   ticket_number: 'Ticket No. {{ticket_number}}',
   order_state: {
    ready_for_collection: 'Ready for collection',
    in_progress: 'In Progress'
   },
   empty_message: 'You don\'t have any orders yet'
  },
  explore: {
   title: 'Explore',
   browse_all_products: 'Browse All Products',
   search_placeholder: 'Input Product Name',
   hint: 'Hint: Try entering some express codes found around the Coco Game Center',
   tutorial: 'View The Tutorial'
  },
  product_groups: {
   title: 'Products',
   exclusive: 'Exclusive'
  },
  product_search_result: {
   title: 'Product search result',
   add_to_bag: 'Add to Bag',
   added_to_bag: 'Added To Shopping Bag',
   continue: 'Continue',
   out_of_stock: 'Sold Out'
  },
  thank_you: {
   title: 'Thank You',
   sorry: 'Sorry',
   message: 'Thank you for using our self-serving kiosk.',
   wechat_discover_message: 'Discover more at our official wechat account',
   session_expired: 'Session Not Found',
   session_expired_message: 'If you would like to make another purchase, please use our self checkout kiosks'
  },
  info_form: {
   title: 'Personal Details',
   register_message: 'Register as our member to enjoy exclusive offers and privileges.',
   first_name: 'Given Name',
   last_name: 'Surname',
   phone: 'Mobile Number',
   required: 'Required',
   accept_pics: 'I would like to receive direct marketing communications as described in the ',
   pics_title: 'Personal Information Collection Statement',
   accept_pics_2: ' above through e-mail, telephone, social media, SMS, instant messaging, mail and anyother means I may consent to from time to time.',
    pics: 'You hereby consent, for yourself and on behalf of any other person whose personal data you have provided, to Chanel, together with our parent and affiliates ("CHANEL") using the personal data you have provided (the"Personal Data") for sales control and records purposes, to personalize your experience with CHANEL based onyour personal attributes, dates of significance to you and other Personal Data, administering product deliveriesand returns, providing customer service and addressing your enquiries and complaints, for research and product development purposes and, subject to your consent, for direct marketing purposes in relation to CHANEL fashion and accessories, watches and fine jewellery, and fragrance and beauty products. Subject to your consent, you agree that Personal Data may be shared, disclosed or transferred to the CHANEL group of companies worldwideand to agents and providers of administrative, marketing and research services for such purposes. CHANEL will honour your request not to use Personal Data for the marketing purposes noted above. If you wish to make sucha request, please contact the Customer Service Officer. You hereby consent to the transfer of Personal Data toplaces outside Hong Kong to carry out the purposes, or directly related purposes, as described in this statement.You have a right to request access to, correction or deletion of Personal Data. If you want your name to be removed from our contact and mailing list or you want to make enquiries concerning Personal Data (including making access and correction), please address to the Customer Service Officer, CHANEL HONG KONG LIMITED, 41/F Gloucester Tower, The Landmark, Central, Hong Kong (Email address: customerservice@chanel.com.hk). Further information about CHANEL Privacy Policy can be obtained at www.chanel.com.hk',
   place_order: 'Place Order',
   guest_checkout: 'Continue As Guest'
  },
 },
 header_menu: {
  menu: 'menu',
  search: 'search',
  cart: 'Cart',
  my_qr: 'OrderHistory'
 },
 searchbar: {
  placeholder: 'search',
  cancel: 'cancel',
  reset: 'reset'
 },
 shades_list: {
  title: 'Select a Shade'
 },
 sizes_list: {
  title: 'Select a Size'
 },
 empty_product_search_result: {
  title: `
   Sorry, we couldn't find<br />
   any matches for<br />
   <div class="keyword">"{{keyword}}"</div>
  `,
  message: 'Try another search term'
 },
 payment_options_bottom_sheet: {
  select_payment: 'Select Payment'
 }
}



// WEBPACK FOOTER //
// ./src/locales/en.js